export default __webpack_public_path__ + "files/1_1_2_3_Social_and_Environmental_check_list.docx";